type AddHandler = {
  message?: string;
};

/* eslint-disable no-param-reassign */

class CloseBrowserTabDetector {
  protected message = '';

  constructor({ message }: AddHandler) {
    if (message) {
      this.message = message;
    }
  }

  init() {
    this.handlerBeforeUnload = this.handlerBeforeUnload.bind(this);
    this.addEventListener();
  }

  destroy() {
    window.removeEventListener('beforeunload', this.handlerBeforeUnload);
  }

  protected addEventListener() {
    window.addEventListener('beforeunload', this.handlerBeforeUnload);
  }

  protected handlerBeforeUnload(event: BeforeUnloadEvent) {

    if (this.message) {
      event.preventDefault();
      event.returnValue = this.message;

      return 'Are you sure?';
    }
    event.returnValue = null;

    return null;
  }
}

export default CloseBrowserTabDetector;
